var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.632 28.6287L23.6125 39.877C22.1002 41.5784 19.4535 41.5784 17.9411 39.877L7.92161 28.6287C6.6928 27.2108 6.6928 25.0368 7.92161 23.6189L17.9411 12.3706C19.4535 10.6692 22.1002 10.6692 23.6125 12.3706L33.632 23.6189C34.8609 25.0368 34.8609 27.2108 33.632 28.6287Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4483 15.4899L29.284 12.2761C30.7964 10.5746 33.443 10.5746 34.9554 12.2761L44.9749 23.5244C46.2037 24.9423 46.2037 27.1163 44.9749 28.5342L34.9554 39.7825C33.443 41.4839 30.7964 41.4839 29.284 39.7825L26.4483 36.5687",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.548545a0df00731ed5cd902d48bff0d9.svg";
export { ForwardRef as ReactComponent };